// SPDX-License-Identifier: AGPL-3.0-or-later

import RuntimeConfig from '@app/features/app/state/RuntimeConfig';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import {type BrandSvgProps, getDataFlx, getImageSizingProps} from './BrandImageUtils';

const APPLICATION_LOGO_DESCRIPTOR = msg({
	message: '{productName} application logo',
	comment: 'Accessible label for the application logo.',
});

export const FluxerLogo = observer((props: BrandSvgProps) => {
	const {i18n} = useLingui();
	const ariaLabel = i18n._(APPLICATION_LOGO_DESCRIPTOR, {productName: RuntimeConfig.productName});
	return (
		<img
			{...getImageSizingProps(props)}
			src={RuntimeConfig.logoUrl ?? '/coret-brand/coret-logo.png'}
			alt={ariaLabel}
			data-flx={getDataFlx(props, 'ui.icons.fluxer-logo.img')}
		/>
	);
});
